import angular from 'angular';
import { redirectToApollo } from '../../utility/redirectToApollo';
// It's a helpers for angular app to work with v2
export default angular
    .module('doxy.common.services.v2', [])
    .factory('v2', ($ngRedux, v2Prefix, $log, institutionHelper) => {
    const isEnabled = () => !Boolean(institutionHelper.domain);
    const isSignInEnabled = () => !Boolean(institutionHelper.domain);
    const redirect = async (path, passcode, lang, queryParams) => {
        $log.info('Redirecting to V2', path);
        await redirectToApollo(v2Prefix, path, passcode, lang, queryParams);
    };
    return {
        isEnabled,
        isSignInEnabled,
        redirect,
    };
}).name;
